module.exports = Function.prototype.bind.call(Function.call, Object.prototype.hasOwnProperty)
